import { render, staticRenderFns } from "./ManualWidget.vue?vue&type=template&id=9668de5a&scoped=true&"
import script from "./ManualWidget.vue?vue&type=script&lang=js&"
export * from "./ManualWidget.vue?vue&type=script&lang=js&"
import style0 from "./ManualWidget.vue?vue&type=style&index=0&id=9668de5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9668de5a",
  null
  
)

export default component.exports